/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this.parent = this.closest('.product-recommendations--parent');
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');
						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}
				}
			this.classList.add('product-recommendations--loaded');
				
				// Set up BUY NOW button redirect functionality
			this.setupBuyNowRedirect();
			})
			.catch(e => {
				console.error(e);
			});
	}
	
	setupBuyNowRedirect() {
		// First, disable any quick view triggers in the recommendations section
		const quickViewTriggers = this.querySelectorAll('.quick-view-trigger, [data-quick-view-trigger], .quick-add, .quick-shop, .quick-add-button');
		quickViewTriggers.forEach(trigger => {
			// Remove existing event listeners by cloning and replacing
			const newTrigger = trigger.cloneNode(true);
			trigger.parentNode.replaceChild(newTrigger, trigger);
			// Hide these elements for certainty
			newTrigger.style.display = 'none';
		});
		
		// Target all "BUY NOW" buttons and links in product recommendations
		const buyButtons = this.querySelectorAll('.button, .btn, a.button, button.button, a[href*="options"]');
		
		buyButtons.forEach(button => {
			// Remove existing event listeners by cloning and replacing
			const newButton = button.cloneNode(true);
			button.parentNode.replaceChild(newButton, button);
			
			// Add our new click handler
			newButton.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation(); // Stop event from bubbling up
				
				// Get product URL from closest product card
				const productCard = this.closest('.product-card') || this.closest('.card');
				if (!productCard) return;
				
				const productLink = productCard.querySelector('a[href*="/products/"]');
				if (productLink) {
					window.location.href = productLink.href;
				}
			}, true); // Use capturing instead of bubbling
		});
		
		// Add a global capturing event listener to prevent quick view
		document.addEventListener('click', function(e) {
			// If click is within product recommendations
			if (e.target.closest('#shopify-section-product-recommendations, .product-recommendations')) {
				// If it's a button or something that might trigger quick view
				if (e.target.matches('.button, .btn, [data-quick-view-trigger], .quick-add, .quick-shop, .quick-add-button, a[href*="options"]')) {
					// Check if it's a BUY NOW button by text content or class
					if (e.target.textContent.includes('BUY NOW') || 
						e.target.classList.contains('button') ||
						e.target.classList.contains('btn')) {
						e.preventDefault();
						e.stopPropagation();
						
						// Find the product link
						const productCard = e.target.closest('.product-card') || e.target.closest('.card');
						if (!productCard) return;
						
						const productLink = productCard.querySelector('a[href*="/products/"]');
						if (productLink) {
							window.location.href = productLink.href;
						}
					}
				}
			}
		}, true); // Use capturing to get event before other handlers
	}
	
	connectedCallback() {
		this.fetchProducts();
	}
}
customElements.define('product-recommendations', ProductRecommendations);